import BaseClient from '@/app/model/api/response/baseApiClient'

class UploadImgApi extends BaseClient {
  public getUploadImg (data: any) {
    const path = '/v1/upload/image'
    const formData = new FormData()
    formData.append('image', data.image)
    formData.append('planting_id', data.planting_id)
    formData.append('record_date', data.record_date)
    if (data.main_number === null) {
      formData.append('main_number', '')
    } else {
      formData.append('main_number', String(data.main_number))
    }

    /* 共通処理 */
    return super.donotUseContentType().setBody(formData).doFetch(process.env.VUE_APP_API_URL + path, 'POST')
  }
}

export default new UploadImgApi()
